// extracted by mini-css-extract-plugin
module.exports =  {"boxSelection":"NA_D0A","boxSelectionOption":"MZuTqh","boxSelectionOptionText":"CffI3J","disabled":"A67VsN","selected":"vDrJ9k"};